import React, { Component } from 'react';
import { Icon } from '@beisen/chaos-ui';
import classNames from 'classnames';
import { addEnNavClassName } from '../../util/ui';

class SearchNav extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.state = {
            showClose: props['inputValue'] ? true : false
        };
    }

    handleClear(e) {
        e.preventDefault();
        this.props.onClearValue && this.props.onClearValue();
    }

	onChange(e) {
		let { onChange } = this.props;
		if(!this.state.showClose) {
			this.setState({
				showClose: true
			});
		}
		onChange && onChange(e);
	}


	render() {
		let { style ,placeholder ,onChange ,cancelFn ,inputValue, translation } = this.props;
		let closeStyle  = {};
		if(!this.state.showClose) {
			closeStyle.display = 'none';
        }
        const enNavButtonClass = addEnNavClassName();
		return (
			<header className='search-nav' style={style}>
				<a href='javascript:;' className={classNames('clear-btn', enNavButtonClass)} onTouchTap={this.handleClear}>{translation.clear}</a>
				<div className='search-input'>
					<Icon icon='m-sys-sousuo' size='small' className='search-icon' />
					<input placeholder={placeholder} onChange={onChange} value={inputValue} />
				</div>
				<a href='javascript:;' className={classNames('clear-btn', enNavButtonClass)} onTouchTap={cancelFn}>{translation.cancel}</a>
			</header>
		);
	}
}

export default SearchNav;



// WEBPACK FOOTER //
// ./src/components/Field_Components/LookUp/SearchNav.js